import { Network } from './network';

type ApiMapping = Record<
  Network,
  (accountAddress: string) => {
    balance: string;
    nftsOwned: string;
  }
>;

export type ApiType = 'balance' | 'nftsOwned';

export const apiMapping: ApiMapping = {
  mainnet: (accountAddress: string) => ({
    balance: `https://stacks-node-api.mainnet.stacks.co/extended/v1/address/${accountAddress}/balances`,
    nftsOwned: `https://stacks-node-api.mainnet.stacks.co/extended/v1/tokens/nft/holdings?principal=${accountAddress}&&`,
  }),
  testnet: (accountAddress: string) => ({
    balance: `https://stacks-node-api.testnet.stacks.co/extended/v1/address/${accountAddress}/balances`,
    nftsOwned: `https://stacks-node-api.testnet.stacks.co/extended/v1/tokens/nft/holdings?principal=${accountAddress}&&`,
  }),
  mocknet: (accountAddress: string) => ({
    balance: `http://localhost:3999/extended/v1/address/${accountAddress}/balances`,
    nftsOwned: `http://localhost:3999/extended/v1/tokens/nft/holdings?principal=${accountAddress}&&`,
  }),
};
